export default __webpack_public_path__ + "static/media/img_5.ad429810.png";